// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"d0ed9a22","221":"2458a990","294":"d2eb5c8b","357":"2c066e4a","371":"cb229b7a","453":"eb9b73df","576":"2d1675bd","615":"5a027336","722":"719e082b","823":"1ca0b41a","832":"67c8e907","855":"b7adc686","858":"d5051265","918":"2f845819"}[chunkId] + ".chunk.js";
};